import BackgroundImage from 'components/BackgroundImage.js'
import { COLUMN_ITEM_SIZE_BIG, COLUMN_ITEM_SIZE_SMALL } from 'components/ColumnItem/constants'
import PropTypes from 'prop-types'
import React from 'react'
import Link from 'components/Link'
import { createSelector } from 'reselect'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { connect } from 'react-redux'

function ColumnItemImage (props) {
  const { isSmallScreen, isSmall, url, image } = props

  return (
    <div
      style={{
        height: isSmallScreen || isSmall
          ? COLUMN_ITEM_SIZE_SMALL
          : COLUMN_ITEM_SIZE_BIG
      }}
    >
      <Link to={url}>
        <BackgroundImage
          bdr
          source={image}
        />
      </Link>
    </div>
  )
}

ColumnItemImage.defaultProps = {
  hasBorderRadiusBottom: null
}

ColumnItemImage.propTypes = {
  image: PropTypes.string.isRequired,
  isSmallScreen: PropTypes.bool,
  isSmall: PropTypes.bool,
  url: PropTypes.string.isRequired
}

const select = () => createSelector(
  isSmallScreenViewportSelect,
  (isSmallScreen) => ({
    isSmallScreen
  })
)

export default connect(select)(ColumnItemImage)
